import axiosInstance from './axios-instance';
import {
  PostUserFollowResponseDTO,
  GetListArticlesResponseDTO,
  GetListRecommendTopicResponseDTO,
  GetListTopicResponseDTO,
  GetListUserResponseDTO,
  GetUserResponseDTO,
  UserControllerGetMeParams,
  PostUserUnFollowResponseDTO,
  GetUserIdResponseDTO,
  GetListCommentByUserResponseDTO
} from '@twygs/shared/publisher-interface';

export const fetchListArticle = async (params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(`/api/v1/publisher/articles`, {
    params: params
  });
  return result.data;
};

export const fetchBreakingNewArticles = async (params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/breaking-news`,
    {
      params
    }
  );
  return result.data;
};

export const fetchMyReadingList = async (params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/saved`,
    {
      params: params
    }
  );
  return result.data;
};

export const fetchListForYou = async (params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/for-you`,
    {
      params: params
    }
  );
  return result.data;
};

export const fetchListRecent = async (params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/recent`,
    {
      params: params
    }
  );
  return result.data;
};

export const fetchListFollowing = async (params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/list-following`,
    {
      params: params
    }
  );
  return result.data;
};

export const fetchListTopic = async () => {
  const result: GetListTopicResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/topics`
  );
  return result.data;
};

export const fetchListRecommendedTopics = async (params) => {
  const result: GetListRecommendTopicResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/recommend-topics`,
    {
      params
    }
  );
  return result.data;
};

export const fetchListFeaturedVoices = async (pagination, userId) => {
  const result: GetListUserResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/user/featured-voices`,
    {
      params: { ...pagination, userId }
    }
  );
  return result.data;
};

export const getUserInfo = async () => {
  const result: GetUserResponseDTO = await axiosInstance.get(`/api/v1/publisher/user/get-me`, {
    params: {
      isDetail: true
    } as UserControllerGetMeParams
  });
  return result.data;
};

export const getUserById = async (userId) => {
  const result: GetUserIdResponseDTO = await axiosInstance.get(`/api/v1/publisher/user/${userId}`);
  return result.data;
};

export const getUserByUsername = async (username) => {
  const result: GetUserIdResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/user/by-username/${username}`
  );
  return result.data;
};

export const followUser = async (userId) => {
  const result: PostUserFollowResponseDTO = await axiosInstance.post(
    `/api/v1/publisher/user/${userId}/follow`
  );
  return result.data;
};

export const unfollowUser = async (userId) => {
  const result: PostUserUnFollowResponseDTO = await axiosInstance.post(
    `/api/v1/publisher/user/${userId}/unfollow`
  );
  return result.data;
};

export const followUserByUsername = async (username) => {
  const result: PostUserFollowResponseDTO = await axiosInstance.post(
    `/api/v1/publisher/user/username/${username}/follow`
  );
  return result.data;
};

export const unfollowUserByUsername = async (username) => {
  const result: PostUserUnFollowResponseDTO = await axiosInstance.post(
    `/api/v1/publisher/user/username/${username}/unfollow`
  );
  return result.data;
};

export const fetchCommentsByUser = async (params) => {
  const result: GetListCommentByUserResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/comments/by-user`,
    {
      params
    }
  );
  return result.data;
};
